module.exports = __webpack_public_path__ + "img/set-leave.a0640ff2.png";